import { useI18n } from '@udemy/i18n';
import { Progress } from '@udemy/react-messaging-components';
import React from 'react';
/** React prop interface for `CardProgress` */

/**
 *
 * ### CardProgress
 *
 * A specifically configured `Progress` component for use within a card.
 */
export const CardProgress = _ref => {
  let {
    value,
    label
  } = _ref;
  const {
    gettext
  } = useI18n();
  const progressLabel = label !== null && label !== void 0 ? label : gettext('Your progress');
  return /*#__PURE__*/React.createElement(Progress, {
    colorScheme: "green",
    label: progressLabel,
    value: value,
    max: 100,
    showPercentage: true,
    rounded: true
  });
};
//# sourceMappingURL=card-progress.react-component.js.map